import styled from "styled-components";

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserTitle = styled.div`
  font-size: 1.25rem;
  /* line-height: 1.8; */
  color: #ffffff;
  @media (max-width: 768px) {
    line-height: 1.3;
  }
`;

export const UserSubTitle = styled(UserTitle)`
  font-size: 1rem;
`;
